

import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog} from 'lucide-react';
import AppMenuCardTwo from "../../CreateApp/Cards/AppMenuCardTwo";
import ContentMenuCardTwo from "./ContentMenuCardTwo";

const AreYouSurePopUp =({loadingText,title,type ,onClickPopup,closePopUp})=>{

     const dispatch = useDispatch();
     
      
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
        
    return (<>  <div  align="center" className="appDesignPopUpOpacity"> </div>
        <div  align="center" className="AreYouSurePopUp" style={{borderRadius: '20px'}}> 
<h2>Are You Sure That You Want To {title}?</h2>
 
<div className="" style={{display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}> <ContentMenuCardTwo  activeCard={false}type={type}  icon={8} title ={`No`} onClickPopup={
   ()=>{closePopUp()}} />
    <ContentMenuCardTwo loadingText={loadingText} activeCard={true} type={type}  icon={10} title ={`Yes`} onClickPopup={
   ()=>onClickPopup(type)} /></div>
   
<div></div>
   
   </div>   </>)
}
export default AreYouSurePopUp;

